<template>
    <div class="pa-5">
        <div v-for="item in activeShop.contacts" :key="item.id" v-if="activeShop.contacts">
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Name" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.name ? item.name : "-" }}
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Phone" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.phone ? item.phone : "-" }}
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Position" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.position ? item.position : "-" }}
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Email" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.email ? item.email : "-" }}
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Additional info" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.additional_field ? item.additional_field : "-" }}
                </v-col>
            </v-row>
            <v-divider class="my-2" />
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "contacts-info-tab",
    data() {
        return {};
    },
    computed: {
        ...mapState("ShopsAdminStore", ["activeShop"])
    },
    methods: {}
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 8px;
    padding-bottom: 8px;
}

.dot {
    margin-right: 10px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}
</style>
